import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {firstValueFrom} from 'rxjs';
import { environment } from '../../environments/environment';

/*
 * Loads configuration properties at runtime for this application
 */
@Injectable()
export class ConfigService {

    uploaderUrl = 'http://localhost:9000/';
       baseHref = '/';
    environment = 'local';


    constructor(private http: HttpClient) {
        this.loadProps().then(returnedProps => {
            // Sets values asynchronously - not immediately available to app
            // component, but sufficient for basic props used by subcomponents
            const props = JSON.parse(returnedProps);
            this.uploaderUrl = props.uploaderUrl;
            this.baseHref    = props.baseHref;
            this.environment = props.environment;
        });
    }


    loadProps() {
        return firstValueFrom(this.http.get(environment.is_local ? 'HMLDashboard-props.json' : 'assets/HMLDashboard-props.json', {
                responseType: 'text'
            }))
            .then(response => response)
            .catch(this.handleError);
    }


    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}
